import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const generateCommerceCloudPaymentMethodImport = {
  name: "generateCommerceCloudPaymentMethodImport" as const,
  input: z.object({ integrationId: commerceCloudIntegrationId }),
  output: z.object({ fileName: z.string(), zipBase64: z.string() }),
};
